import { styled } from '../../../../utils/styled';
import { propStyles } from '../../../../utils/propStyles';

const StyledComponent = styled<any, any>(
    'div',
    'documentCardActionsLabel',
    'documentsGrid'
)`
    ${propStyles};
    display: inline-flex;
    align-items: center;
`;

export default StyledComponent;



// WEBPACK FOOTER //
// ./src/Components/Document/DocumentsGrid/StyledComponents/DocumentCardActionsLabel.tsx